/* eslint-disable no-console */
import StyledToolBar from './styles';

import toolsMapper from './utils/toolsMapper';

import AppContext from '@map/services/context';
import Skeleton from '@material-ui/lab/Skeleton';
/**
 * useState é um hook que nos permite rastrear o estado em um
 * componente de função, o estado geralmente se refere a dados ou
 * propriedads que precisam ser rastreador em um aplicativo.
 * 
 * useEffect é um hook que permite executar efeitos colaterais em
 * seus componentes, por exemplo: buscar dados, atualizar diretamente
 * o DOM e cronômetros, ele aceita dois argumentos o segundo é opcional.
 * 
 * useContext usado para forcener uma maneira de passar dados
 * pela arvore de componentes sem ter que passar props manualmente
 * em todos os níveis.
 */
import { useState, useEffect, useContext } from 'react';
/**
 *  useModules é responsavel por gerenciar os modulos do GeoBahia,
 *  todos os módulos criados na ADM.
 * 
 *  useMap é um hook personalizado criado para gerenciar a comunicação
 *  dos componentes com o mapa.
 */
import { useModule, useMap } from 'views/MapView/hooks';

/**
 * Barra de Ferramentas, é onde ficam dispostas as ferramentas
 * do módulo, agrupadas por categoria, e ordenadas conforme definido
 * na configuração do módulo.
 */
const ToolBar = () => {
  const [activeTool, setActiveTool] = useState(null);
  const context = useContext(AppContext);
  const [tools, setTools] = useState(null);

  const { layersCatalogIsOpened } = context;
  const { activeModule } = useModule();
  const { map, loadingMap } = useMap();

  const handleActiveTool = (toolName) => {
    setActiveTool(activeTool === toolName ? null : toolName);
  };
  
  useEffect(() => {
    if (map) {      
      if (activeTool) {
        map.getPane('overlayPane').style.display = 'block'
      } else{
        map.getPane('overlayPane').style.display = 'none';
      }
    }        
  }, [activeTool, map]);


  // Observando troca de módulo para carregamento de novas ferramentas
  useEffect(() => {
    if (activeModule && activeModule.elementosConfig) {
      const elementosConfig = Object.values(activeModule.elementosConfig);
      elementosConfig.sort((a, b) => {
        let orderA = a && a.ordem;
        let orderB = b && b.ordem;
        if (orderA && orderB) {
          if (orderA > orderB) return 1;
          else if (orderA < orderB) return -1;
          return 0;
        } else {
          if (!orderA && orderB) return -1;
          else if (orderA && !orderB) return 1;
          return 0;
        }
      });
      let categories = elementosConfig.filter(
        (v) => v.elemento_pai && v.elemento_pai === 'CPN-TOOL_BAR'
      );
      let newTools = [];
      categories.forEach((c) => {
        let categorieTools = elementosConfig.filter(
          (v) => v.elemento_pai && v.elemento_pai === c.elemento_codinome
        );
        if (categorieTools && categorieTools.length) {
          newTools.push({ ...c, tools: categorieTools });
        }
      });
      setTools(newTools);
      setActiveTool(null);
    }
  }, [activeModule]);

  // Desabilitando a ferramenta ativa quando o catalogo de camadas é aberto
  useEffect(() => {
    layersCatalogIsOpened && setActiveTool(null);
  }, [layersCatalogIsOpened]);

  return (
    <StyledToolBar isHided={context.hidedInterface}>
      <div className="main-tools">
        {loadingMap ? (
          <>
            <Skeleton variant="circle" /> <Skeleton variant="circle" />
            <Skeleton variant="circle" /> <Skeleton variant="circle" />
            <Skeleton variant="circle" /> <Skeleton variant="circle" />
          </>
        ) : (
          map &&
          tools &&
          tools.map((c, i) => {
            if (c.elemento_codinome === 'CAT-TB-PERMANENT') {
              return null;
            }
            let visibleTools = c.tools.filter(
              (t) => t.configuracao && t.configuracao.mainMenu
            );
            return [
              i !== 0 && visibleTools.length ? (
                <div className="spacer" />
              ) : null,
              visibleTools.map((t) => {
                let Tool = toolsMapper[t.elemento_codinome];
                return (
                  Tool && (
                    <Tool
                      mapContext={context}
                      isActive={activeTool === t.elemento_codinome}
                      setIsActive={() => handleActiveTool(t.elemento_codinome)}
                    />
                  )
                );
              }),
            ];
          })
        )}
      </div>
      <div className="permanent-tools">
        {loadingMap ? (
          <>
            <Skeleton variant="circle" />
            <Skeleton variant="circle" />
            <Skeleton variant="circle" />
          </>
        ) : (
          map &&
          tools &&
          tools.map((c, i) => {
            if (c.elemento_codinome === 'CAT-TB-PERMANENT') {
              return [
                c.tools.map((t) => {
                  let Tool = toolsMapper[t.elemento_codinome];
                  return (
                    Tool && (
                      <Tool
                        mapContext={context}
                        isActive={activeTool === t.elemento_codinome}
                        setIsActive={() =>
                          handleActiveTool(t.elemento_codinome)
                        }
                      />
                    )
                  );
                }),
              ];
            } else {
              return null;
            }
          })
        )}
      </div>
    </StyledToolBar>
  );
};
ToolBar.properties = {
  id: 'CPN-TOOL_BAR',
  alias: 'Barra de Ferramentas',
  description: '...',
};

export default ToolBar;
